export default __webpack_public_path__ + "static/media/MM.752ba9c5.ico";